import { urlEncodeObject } from 'mini-helper';
import api from '~/services/Api';

export async function checkPassport(passport) {
  if (!passport || passport <= 0) return false;
  const query = urlEncodeObject({ passport });
  const result = await api.get(`/session/passport/?${query}`);
  return result && result.data;
}
